export const InterlaceOffsets = [0, 4, 2, 1];
export const InterlaceSteps = [8, 8, 4, 2];
